import React, { useState } from 'react';
import { Box, Typography, Divider, Tabs, Tab } from '@mui/material';
import { FeaturedNews, NewsList, NewsSlider } from '../components/news';
import { useNews } from '../hooks';
import SEOMetaTags from '../components/SEOMetaTags';

const HomePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  
  const {
    news,
    pagination,
    loading,
    error,
    featuredNews,
    loadingFeatured,
    latestNews,
    loadingLatest,
    changePage
  } = useNews();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Convert from pagination object to the one NewsList component expects
  const paginationProps = {
    count: pagination.totalPages,
    page: pagination.number + 1,
    onChange: (event: React.ChangeEvent<unknown>, page: number) => {
      changePage(page - 1);
    }
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <SEOMetaTags
        title="Ana Sayfa"
        description="Akademik Kadro - Güncel haberler, son dakika gelişmeleri, ekonomi, siyaset, spor, eğitim ve kültür haberleri"
        keywords="akademik kadro, haber, güncel haberler, son dakika, siyaset, ekonomi, spor, eğitim"
        url={window.location.href}
        type="website"
      />
      
      {/* Main content */}
      <Box sx={{ px: { xs: 1, md: 0 } }}>
        {/* Latest News Slider */}
        <NewsSlider
          news={latestNews}
          loading={loadingLatest}
          title="Son Haberler"
        />

        {/* Featured News Section */}
        <FeaturedNews
          featuredNews={featuredNews}
          loading={loadingFeatured}
          showAds={true}
        />
        
        <Divider sx={{ mb: 6 }} />
        
        {/* Latest News Section */}
        <Box sx={{ mb: 8 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="news tabs"
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Son Haberler" id="tab-0" aria-controls="tabpanel-0" />
            </Tabs>
          </Box>
          
          <Box role="tabpanel" hidden={activeTab !== 0} id="tabpanel-0" aria-labelledby="tab-0">
            {activeTab === 0 && (
              <NewsList
                news={news}
                loading={loading}
                error={error}
                pagination={paginationProps}
                emptyMessage="Henüz haber bulunmamaktadır."
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HomePage; 